/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * A payment made through a payment link with no amount
 */
export type OpenPaymentLinkOperationDTO = {
  amount?: number;
  createdAt?: string;
  operationId?: string;
  payerEmail?: string;
  paymentMethod?: OpenPaymentLinkOperationDTO.paymentMethod;
  receiptNumber?: number;
  status?: OpenPaymentLinkOperationDTO.status;
  transactionId?: string;
};

export namespace OpenPaymentLinkOperationDTO {
  export enum paymentMethod {
    CASH = "CASH",
    POS = "POS",
    POS_ORDER = "POS_ORDER",
    USSD = "USSD",
    QR_CODE = "QR_CODE",
    INWARDS_TRANSFER = "INWARDS_TRANSFER",
    PAY_WITH_TRANSFER = "PAY_WITH_TRANSFER",
    MOMO = "MOMO",
    PAYMENT_LINK = "PAYMENT_LINK",
    PAYMENT_LINK_CARD = "PAYMENT_LINK_CARD",
    PAYMENT_LINK_USSD = "PAYMENT_LINK_USSD",
    PAYMENT_LINK_QR_CODE = "PAYMENT_LINK_QR_CODE",
    PAYMENT_LINK_PAY_WITH_TRANSFER = "PAYMENT_LINK_PAY_WITH_TRANSFER",
    OUT_BANK_TRANSFER = "OUT_BANK_TRANSFER",
    REFUND = "REFUND",
    CARD = "CARD",
    TRANSACTION_CHARGE = "TRANSACTION_CHARGE",
    MANUAL_CREDIT = "MANUAL_CREDIT",
    MANUAL_DEBIT = "MANUAL_DEBIT",
    OUTLET_WITHDRAWAL = "OUTLET_WITHDRAWAL",
  }

  export enum status {
    SUCCESS = "SUCCESS",
    EXPIRED = "EXPIRED",
    PENDING = "PENDING",
    PENDING_CREDIT = "PENDING_CREDIT",
    DECLINED = "DECLINED",
    FAILED = "FAILED",
  }
}
